import { render, staticRenderFns } from "./ShippingFormByLineAutoCloseWithCoupon.vue?vue&type=template&id=704b908a&scoped=true&"
import script from "./ShippingFormByLineAutoCloseWithCoupon.vue?vue&type=script&lang=js&"
export * from "./ShippingFormByLineAutoCloseWithCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ShippingFormByLineAutoCloseWithCoupon.vue?vue&type=style&index=0&id=704b908a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b908a",
  null
  
)

export default component.exports